import Field from "./Field"

export default function DefaultLayout({ fields, children, controls }) {
  const { Submit, Cancel } = controls

  return (
    <div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-5">
        {fields.map((field) => (
          <Field key={field.id} fieldKey={field.key} />
        ))}
      </div>
      {children}
      <div className="mt-5">
        <Submit />
        <Cancel />
      </div>
    </div>
  )
}
